import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { getWorkOrderChange } from '../WorkOrderChangeQueries';

export const useGetWorkOrderChange = ({ workOrderChangeId }: { workOrderChangeId: number | null }) => {
    const dispatch = useDispatch();
    const variables = useMemo(() => ({ workOrderChangeId }), [workOrderChangeId]);

    const [workOrderChangeData, , , workOrderChangeRequest] = useRequest({
        requestId: 'workOrderChange',
        query: getWorkOrderChange,
        withEffect: !!workOrderChangeId,
        variables,
    });

    const refreshWorkOrderChangeData = useCallback(() => {
        dispatch(workOrderChangeRequest(variables));
    }, [dispatch, variables, workOrderChangeRequest]);

    return { workOrderChangeData: workOrderChangeData?.uerWorkOrderChange?.data, refreshWorkOrderChangeData };
};
